"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _money = require("../global/utils/money");

var _react = _interopRequireWildcard(require("react"));

var _InvoiceDetailsModule = _interopRequireDefault(require("./InvoiceDetails.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function InvoiceTable(props) {
  var total = props.total,
      lineItems = props.lineItems,
      hasDiscount = props.hasDiscount,
      displayDiscount = props.displayDiscount,
      discountPrice = props.discountPrice; // Why they want a table the looks like butt on small screens is a mystery to me

  return /*#__PURE__*/_react.default.createElement("table", {
    className: _InvoiceDetailsModule.default.table
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Description"), /*#__PURE__*/_react.default.createElement("th", null, "Qty"), /*#__PURE__*/_react.default.createElement("th", null))), /*#__PURE__*/_react.default.createElement("tbody", null, lineItems.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: "".concat(item.name, "-").concat(index)
    }, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
      className: _InvoiceDetailsModule.default.description
    }, item.name, item.description ? ' - ' : '', item.description), /*#__PURE__*/_react.default.createElement("td", null, item.quantity), /*#__PURE__*/_react.default.createElement("td", {
      className: _InvoiceDetailsModule.default.itemPrice
    }, "$", item.price)), /*#__PURE__*/_react.default.createElement("tr", {
      className: _InvoiceDetailsModule.default.spacer
    }));
  }), hasDiscount && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _InvoiceDetailsModule.default.description
  }, "Order discount (", displayDiscount, ")"), /*#__PURE__*/_react.default.createElement("td", null), /*#__PURE__*/_react.default.createElement("td", {
    className: _InvoiceDetailsModule.default.itemPrice
  }, discountPrice)), /*#__PURE__*/_react.default.createElement("tr", {
    className: _InvoiceDetailsModule.default.spacer
  }))), /*#__PURE__*/_react.default.createElement("tfoot", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null), /*#__PURE__*/_react.default.createElement("td", null, "Total"), /*#__PURE__*/_react.default.createElement("td", {
    className: _InvoiceDetailsModule.default.tFootTotal
  }, "$", total))));
}
/**
 * ==================
 * EXPORTED COMPONENT
 * ==================
 */


var InvoiceDetails = function InvoiceDetails(props) {
  var total = props.total,
      _props$idObj = props.idObj,
      label = _props$idObj.label,
      value = _props$idObj.value,
      lineItems = props.lineItems,
      startExpanded = props.startExpanded,
      gaEventHandlers = props.gaEventHandlers,
      discountAmount = props.discountAmount,
      discountMethod = props.discountMethod,
      subTotal = props.subTotal;

  var _useState = (0, _react.useState)(startExpanded !== undefined ? startExpanded : lineItems.length === 1 ? true : false),
      _useState2 = _slicedToArray(_useState, 2),
      showFullDetails = _useState2[0],
      setShowFullDetails = _useState2[1];

  var hasDiscount = !!discountAmount;
  var displayDiscount = discountMethod === 'amount' ? "$".concat(discountAmount) : "".concat(discountAmount, "%");
  var discountPrice = "-".concat((0, _money.getDiscountPrice)((0, _money.centsToDollar)(subTotal), discountAmount, discountMethod));

  var handleClick = function handleClick() {
    setShowFullDetails(function (state) {
      /**
       * state ? 'collapsed' : 'expanded'
       * ^^^ This might be confusing at first, here is the explanation:
       * state is a boolean value
       * We toggle it between true and false by returning !state
       *
       * If state === true it means that the details are currently expanded
       * so when we return !state the details will collapse
       *
       * So you can think of the ternary expression as saying,
       * if state is currently true then we are about to collapse the details
       * but if state is currently false we are about to expand the details
       */
      if (typeof (gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.click) === 'function') gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.click(state ? 'collapsed' : 'expanded');
      return !state;
    });
  };

  (0, _react.useEffect)(function () {
    var startingState = startExpanded !== undefined ? 'expanded' : lineItems.length === 1 ? 'expanded' : 'collapsed';
    if (typeof (gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.load) === 'function') gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.load(startingState);
    /**
     * We only want this to run once when the component loads
     * so it is safe to ignore the hooks/exhaustive-deps warning
     * eslint-disable-next-line
     */
  }, []);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: showFullDetails ? _InvoiceDetailsModule.default.container : _InvoiceDetailsModule.default.containerCollapsed
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: _InvoiceDetailsModule.default.header
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Amount Due"), /*#__PURE__*/_react.default.createElement("p", {
    className: _InvoiceDetailsModule.default.headerTotal
  }, "$", total), value && /*#__PURE__*/_react.default.createElement("p", {
    className: _InvoiceDetailsModule.default.id
  }, label, ": ", value)), /*#__PURE__*/_react.default.createElement("button", {
    className: _InvoiceDetailsModule.default.btn,
    onClick: handleClick
  }, showFullDetails ? '-' : '+', " Details"), /*#__PURE__*/_react.default.createElement("div", null, showFullDetails ? /*#__PURE__*/_react.default.createElement(InvoiceTable, {
    total: total,
    lineItems: lineItems,
    hasDiscount: hasDiscount,
    displayDiscount: displayDiscount,
    discountPrice: discountPrice
  }) : null));
};

var _default = InvoiceDetails;
exports.default = _default;